import { ApiUserRole } from '@/enum/ApiUserRole'
import { AloBase, getDefaultAloBase } from './AloBase'
import { AloSejour } from './AloSejour'


export interface AloPanStatus extends AloBase {    
    pstColor:string
}

export const getDefaultAloPanStatus = ():AloPanStatus => {
    return {        
        id:-1,
        libelle:'',
        pstColor:'#666666'
    }
}

export const cleanAloPanStatus = (status:AloPanStatus) => {
    if(!status) return    
    if(!status.id) delete status.id
}
